import { render } from "./invitations-page.vue?vue&type=template&id=0e1d1546&ts=true"
import script from "./invitations-page.vue?vue&type=script&lang=ts"
export * from "./invitations-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__